import { createStructuredSelector } from 'reselect'

import {
  EVALUATION_ROLE_LIST,
  EVALUATION_ROLE_LIST_SUCCESS, 
  EVALUATION_ROLE_LIST_ERROR,
  EVALUATION_ROLE_PAGE_SET,
  EVALUATION_ROLE_SEARCH_SET,
  EVALUATION_ROLE_SEARCH_CHANGE,
  EVALUATION_ROLE_ADD_SET,
  EVALUATION_ROLE_ADD_MODAL_SET,
  EVALUATION_ROLE_ADD,
  EVALUATION_ROLE_ADD_SUCCESS,
  EVALUATION_ROLE_ADD_ERROR,
  EVALUATION_ROLE_ADD_CHANGE,
  EVALUATION_ROLE_DETAIL,
  EVALUATION_ROLE_DETAIL_SUCCESS,
  EVALUATION_ROLE_DETAIL_ERROR,
  EVALUATION_ROLE_VIEW_MODAL_SET,
  EVALUATION_ROLE_EDIT_CHANGE,
  EVALUATION_ROLE_EDIT_MODAL_SET,
  EVALUATION_ROLE_UPDATE,
  EVALUATION_ROLE_UPDATE_SUCCESS,
  EVALUATION_ROLE_UPDATE_ERROR,
  EVALUATION_ROLE_VIEW_TAB_SET
} from '../../actions';

export const NAME = 'evaluation_role';

export const EvaluationRoleList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: EVALUATION_ROLE_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const EvaluationRoleListSuccess = (data) => ({
  type: EVALUATION_ROLE_LIST_SUCCESS,
  payload: data
});

export const EvaluationRoleListError = (error) => ({
  type: EVALUATION_ROLE_LIST_ERROR,
  payload: error
});

export const EvaluationRolePageSet = (data) => ({
  type: EVALUATION_ROLE_PAGE_SET,
  payload: data
});

export const EvaluationRoleSearchSet = (data) => ({
  type: EVALUATION_ROLE_SEARCH_SET,
  payload: data
});

export const EvaluationRoleSearchChangeSet = (data) => ({
  type: EVALUATION_ROLE_SEARCH_CHANGE,
  payload: data
});

export const EvaluationRoleAddChangeSet = (data) => ({
  type: EVALUATION_ROLE_ADD_CHANGE,
  payload: data
});

export const EvaluationRoleAddSet = (data) => ({
  type: EVALUATION_ROLE_ADD_SET,
  payload: data
});

export const EvaluationRoleAddModalSet = (data) => ({
  type: EVALUATION_ROLE_ADD_MODAL_SET,
  payload: data
});

export const EvaluationRoleAdd = (data) => ({
  type: EVALUATION_ROLE_ADD,
  payload: data
});

export const EvaluationRoleAddSuccess = (message) => ({
  type: EVALUATION_ROLE_ADD_SUCCESS,
  payload: message
});

export const EvaluationRoleAddError = (error) => ({
  type: EVALUATION_ROLE_ADD_ERROR,
  payload: error
});

export const EvaluationRoleDetail = (data) => ({
  type: EVALUATION_ROLE_DETAIL,
  payload: data
});

export const EvaluationRoleDetailSuccess = (data) => ({
  type: EVALUATION_ROLE_DETAIL_SUCCESS,
  payload: data
});

export const EvaluationRoleDetailError = (error) => ({
  type: EVALUATION_ROLE_DETAIL_ERROR,
  payload: error
});

export const EvaluationRoleViewModalSet = (data) => ({
  type: EVALUATION_ROLE_VIEW_MODAL_SET,
  payload: data
});

export const EvaluationRoleEditModalSet = (data) => ({
  type: EVALUATION_ROLE_EDIT_MODAL_SET,
  payload: data
});

export const EvaluationRoleEditChangeSet = (data) => ({
  type: EVALUATION_ROLE_EDIT_CHANGE,
  payload: data
});

export const EvaluationRoleUpdate = (data) => ({
  type: EVALUATION_ROLE_UPDATE,
  payload: data
});

export const EvaluationRoleUpdateSuccess = (message) => ({
  type: EVALUATION_ROLE_UPDATE_SUCCESS,
  payload: message.message
});

export const EvaluationRoleUpdateError = (error) => ({
  type: EVALUATION_ROLE_UPDATE_ERROR,
  payload: error
});

export const EvaluationRoleViewTabSet = (data) => ({
  type: EVALUATION_ROLE_VIEW_TAB_SET,
  payload: data
});

const evaluation_role = (state) => state[NAME];

export const EvaluationRoleSelector = createStructuredSelector({
  evaluation_role
})
 